export default __webpack_public_path__ + "static/media/google-calendar.af5e0819.png";